module.exports = __webpack_public_path__ + "static/media/icone-ia.53762fb9.svg";